/**
 * Recently Viewed Products
 * ------------------------
 * Reads/writes a list of product handles to localStorage and renders
 * the products (excluding the current one, if any) into the section's
 * grid using Shopify's public product JSON endpoint.
 */
(function () {
  var root = document.querySelector('[data-recently-viewed-products]');
  if (!root) return;

  var STORAGE_KEY = root.dataset.storageKey || 'recently_viewed_products';
  var MAX_STORAGE = parseInt(root.dataset.maxStorage, 10) || 12;
  var COUNT = parseInt(root.dataset.count, 10) || 4;
  var CURRENT_HANDLE = root.dataset.currentHandle || null;
  var grid = root.querySelector('[data-recently-viewed-grid]');
  var template = document.getElementById('recently-viewed-card-template');

  function getStoredHandles() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function setStoredHandles(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      /* localStorage unavailable (private mode, quota, etc.) - fail silently */
    }
  }

  // Record the current product as "viewed", most-recent-first, deduped.
  function recordCurrentProduct() {
    if (!CURRENT_HANDLE) return;
    var list = getStoredHandles();
    list = list.filter(function (handle) {
      return handle !== CURRENT_HANDLE;
    });
    list.unshift(CURRENT_HANDLE);
    if (list.length > MAX_STORAGE) {
      list = list.slice(0, MAX_STORAGE);
    }
    setStoredHandles(list);
  }

  function formatMoney(cents, format) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, format);
    }
    // Minimal fallback if Shopify.money isn't loaded on this template.
    return '₹' + (cents / 100).toFixed(2);
  }

  function buildCard(productJson) {
    var clone = template.content.firstElementChild.cloneNode(true);
    var link = clone;
    var img = clone.querySelector('.recently-viewed-card__image');
    var title = clone.querySelector('.recently-viewed-card__title');
    var price = clone.querySelector('.recently-viewed-card__price');

    var image = productJson.featured_image || (productJson.images && productJson.images[0]);

    link.href = productJson.url;
    title.textContent = productJson.title;

    if (image) {
      img.src = image.replace(/(\.[a-zA-Z0-9]+)(\?.*)?$/, '_400x$1');
      img.alt = productJson.title;
    } else {
      img.remove();
    }

    var variant = productJson.variants && productJson.variants[0];
    if (variant) {
      var priceHtml = formatMoney(variant.price);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceHtml =
          '<s>' + formatMoney(variant.compare_at_price) + '</s> ' + formatMoney(variant.price);
      }
      price.innerHTML = priceHtml;
    } else {
      price.remove();
    }

    return clone;
  }

  function fetchProduct(handle) {
    return fetch('/products/' + handle + '.js')
      .then(function (res) {
        if (!res.ok) throw new Error('Product not found: ' + handle);
        return res.json();
      })
      .catch(function () {
        return null; // product deleted/unpublished since it was viewed
      });
  }

  function render() {
    var handles = getStoredHandles().filter(function (handle) {
      return handle !== CURRENT_HANDLE;
    });

    if (!handles.length) return; // keep section hidden

    var toFetch = handles.slice(0, COUNT);

    Promise.all(toFetch.map(fetchProduct)).then(function (products) {
      var fragment = document.createDocumentFragment();

      products
        .filter(Boolean)
        .forEach(function (productJson) {
          fragment.appendChild(buildCard(productJson));
        });

      if (!fragment.childNodes.length) return; // nothing valid to show

      grid.appendChild(fragment);
      root.hidden = false;
    });
  }

  recordCurrentProduct();
  render();
})();
